/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Creating_ProjectInputs */



/**
* | output |
* | --- |
* | "Creating Project" |
*
* @param {Iconik_Publish_Status_Creating_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_creating_project = /** @type {((inputs?: Iconik_Publish_Status_Creating_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Creating_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt wird erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando Proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट बनाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando um projeto")
	return /** @type {LocalizedString} */ ("Creating Project")
});